import Home from '../views/Home.vue';
import Favourites from '../views/Favourites.vue';
import Jesus from '../views/Jesus.vue';
import Auth from '../views/Auth.vue';

export const routes = [
    { path: '', component: Home },
    { path: '/favourites', component: Favourites },
    { path: '/Jesus', component: Jesus },
    { path: '/Auth', component: Auth }
]


// WEBPACK FOOTER //
// ./src/router/index.js